import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("ux-tooltip", () => {
    it("renders with a p wrapper for text only toolkit", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-tooltip>Hello world</ux-tooltip>`);
        const el = await page.find("ux-tooltip p.ux-text-normal");
        await page.waitForChanges();
        expect(el).not.toBeNull();
    });

    it("matches to snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-tooltip><div>Hello world</div></ux-tooltip>`
        );
        const el = await page.find("ux-tooltip");
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("activates when the target is hovered, deactivates properly", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-icon name="packages"></ux-icon>
            <ux-tooltip tooltip-target="ux-icon[name='packages']" align="left">
                This is the standard look of the tooltip component, just add the
                desired text in between the ux-tooltip tags.
            </ux-tooltip>`
        );
        await page.waitForChanges();
        const el = await page.find("ux-tooltip");
        expect(el).toHaveClass("hydrated");
        const body = await page.find("body");
        const target = await page.find("ux-icon[name='packages']");
        await target.hover();
        await page.waitForChanges();
        const activeTooltip = await page.find(".ux-tooltip__tip--active");
        expect(activeTooltip).toBeTruthy();
        await body.hover();
        await page.waitForChanges();
        await new Promise((res) => setTimeout(res, 1000));
        const unactiveTooltip = await page.find(".ux-tooltip__tip--active");
        expect(unactiveTooltip).toBeFalsy();
    });

    it("activates when the target is clicked, deactivates properly", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-icon name="globe"></ux-icon>
            <ux-tooltip tooltip-target="ux-icon[name='globe']" align="left">
                This is the standard look of the tooltip component, just add the
                desired text in between the ux-tooltip tags.
            </ux-tooltip>`
        );
        await page.waitForChanges();
        const body = await page.find("body");
        const target = await page.find("ux-icon[name='globe']");
        await target.click();
        await page.waitForChanges();
        const activeTooltip = await page.find(".ux-tooltip__tip--active");
        expect(activeTooltip).toBeTruthy();
        await body.click();
        await page.waitForChanges();
        await new Promise((res) => setTimeout(res, 1000));
        const unactiveTooltip = await page.find(".ux-tooltip__tip--active");
        expect(unactiveTooltip).toBeFalsy();
    });

    it("should render valid html", async () => {
        await testValidHtml(`<ux-tooltip><div>Hello world</div></ux-tooltip>`);
    });
});
